import React, { useContext, useMemo } from 'react';
import classnames from 'classnames';
import { useParams, useSelector, shallowEqual, history } from 'umi';
import { Layout, Text, Tabs } from "tea-component";
import { useLocal } from '@/pages/dashboard/utils/customHook';
import ContentWrap from './ContentWrap';
import { IComponentProps, IPageConfigType } from './type';
import SvgIcon from '@/pages/home/components/SvgIcon';
import RefreshCo from '@/pages/dashboard/components/RefreshCo';
import { RefreshContext } from './context';
import componentMap from '@/pages/dashboard/_config/compConfig';
import DefualtComponetCo from '../DefualtComponetCo';
import { useProps } from "@/pages/dashboard/components/PageContainer/Render/hooks";
import Render from './Render';
// import { useLocation } from 'react-router-dom';
import './index.scss';
import { dynamicString } from '@home/utils/dynamicString';
import CommonContantWrap from './CommonContantWrap';
import { getImg } from '@home/_config/getImgs';
import { SYSTEM_PERMISSIONS_MAP } from '@/pages/dashboard/_config/constant';

const { Content } = Layout;
interface IPageContainerProps extends IComponentProps {
  config: IPageConfigType;
  className?: string;
}

const PageContainer = (props: IPageContainerProps) => {
  // @ts-ignore
  const { config: pageConfig, className: systemClassName } = props;
  const { showUnconfiguredPage, unconfiguredComponentName, className = '', style = {}, showTimeZone = true, showHeader = true, system = 'dashboard', icon, titleIcon, timeZone: propsTimeZone } = pageConfig || {};
  const { data, changeData } = useProps(props);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { gameCode, timeZone = '+0', gameConfig, userInfo } = useSelector((state: any) => ({
    gameCode: state?.dashboard?.currentGame?.game_code,
    timeZone: data?.timeZone || propsTimeZone || state?.dashboardSetting?.gameConfig?.time_zone,
    gameConfig: state?.dashboardSetting?.gameConfig || {},
    userInfo: state?.home?.userInfo,
  }), shallowEqual);
  const params = useParams() as any;
  // const queryParams = useLocation();
  // const query = queryParams?.query;
  const historyParam = history?.location?.state;
  // || (query?.hasBack)
  // @ts-ignore
  const hasBack = (historyParam && JSON.parse(historyParam)?.hasBack) || false;
  const { isEN } = useLocal();
  // 点击刷新相关context
  const { reset } = useContext(RefreshContext);

  const tabsInfo = useMemo(() => {
    const tabMap = {} as any;
    const tabList = [] as any;
    const tabs = pageConfig?.tabList?.map(item => {
      const { id, tabName, tabNameCN, tabIcon } = item;
      const label = isEN ? tabName : tabNameCN;
      tabList?.push(id);
      tabMap[id] = item;
      return {
        id,
        label: <div className="dbd-tab-flex">
          {
            tabIcon && <SvgIcon type={tabIcon} className="dbd-tab-icon" />
          }
          {label || tabName || tabNameCN}
        </div>
      };
    });
    return {
      tabs,
      tabMap,
      tabList,
    };
  }, [pageConfig, isEN]);

  const subTitle = useMemo(() => {

    // 没配时区，默认展示0时区
    const subTitle = `Timezone (UTC${timeZone || '+0'})`;
    const subTitleCN = `时区 (UTC${timeZone || '+0'})`;
    const context = { timeZone, ...data };
    if (pageConfig?.subTitle) {
      if (isEN) {
        return dynamicString(pageConfig.subTitle, context) || '';
      }
      return pageConfig.subTitleCN ? dynamicString(pageConfig.subTitleCN, context) : dynamicString(pageConfig.subTitle, context) || '';
    }
    if (!showTimeZone) return '';
    return (isEN && subTitle ? subTitle : subTitleCN) || '';
  }, [pageConfig, showTimeZone, timeZone, isEN, data]);

  const { tabId, hasTab } = useMemo(() => {
    const hasTab = pageConfig?.tabList?.length > 1;
    // 选中配置中的tab
    const tabId = tabsInfo?.tabList?.includes(params?.tab) ? params?.tab : pageConfig?.defaultTab;
    // 配置化页面路径跟请求path一一对应，取消重定向
    // tabList不包含路由的tab，重置为默认的配置tab选项（页面跳转不需要重置）
    // if (!tabsInfo?.tabList?.includes(params?.tab) && hasTab && !hasBack) {
    //   const url = `/dashboard/game/${gameCode}${pageConfig?.path}/${pageConfig?.defaultTab}`;
    //   try {
    //     history.push(url, historyParam);
    //   } catch (error) {
    //     console.log(error, '配置化页面跳转error');
    //     history.push(url);
    //   }
    // }
    return {
      tabId,
      hasTab
    };
  }, [pageConfig, tabsInfo, params]);

  const tab = tabsInfo?.tabMap?.[tabId] || {};

  const renderPage = () => {
    // 针对churn的mobile和pc这两个未配置化的页面临时处理
    const Component = componentMap?.[unconfiguredComponentName];
    if (!Component) {
      return <DefualtComponetCo />;
    }
    return <Component
      timeZone={parseInt(timeZone || '') || 0}
      {...pageConfig?.unconfiguredComponentProps}
    />;
  };

  // 头部操作按钮跟系统权限关联
  const operationList = useMemo(() => {
    // 用户权限
    const permissions = userInfo?.permissions ? Object.keys(userInfo?.permissions || {}) : [];
    const list = pageConfig?.operationList?.map((item) => ({
      ...(item || {}),
      show: SYSTEM_PERMISSIONS_MAP?.[item?.nameCn] ? permissions?.includes(SYSTEM_PERMISSIONS_MAP?.[item?.nameCn]) : true,
    }));
    return list;
  }, [userInfo?.permissions, pageConfig?.operationList]);

  return <>
    {
      showUnconfiguredPage ? <>
        {renderPage()}
      </> : (<Content className={`dbd-scroll-body dbd-custom-page-box ${systemClassName} ${className}`} style={style}>
        {showHeader && (
          <Content.Header
            className={classnames({
              // 有tab导航
              'contentHead-normal': hasTab
            })}
            title={
              <>
                <div
                  className={hasBack ? 'db-header-title' : ''}
                  onClick={() => { hasBack && history.goBack() }}
                >
                  {hasBack && <SvgIcon className='db-header-title-icon' type='arrow-left'></SvgIcon>}
                  {
                    pageConfig?.title?.name ? <Render config={pageConfig?.title} data={data} changeData={changeData} /> : (isEN ? pageConfig?.title : pageConfig?.titleCN)
                  }
                </div>
              </>
            }
            subtitle={
              <div className='db-header-subtitle'>
                {icon && (
                  <div className="db-header-subtitle-svg-icon">
                    <SvgIcon type={icon} className="text-icon" />
                  </div>
                )}
                {titleIcon && (
                  <img className='db-header-subtitle-img-icon' src={getImg(titleIcon)} />
                )}
                {pageConfig?.subTitle || subTitle ? <Text theme="label">{subTitle}</Text> : undefined}
              </div>
            }
            operation={
              <>
                {tab.refresh ? <RefreshCo config={tab.refreshConfig} /> : undefined}
                {operationList && operationList?.length > 0 && (!tab.operationList || tab.operationList.length === 0) &&
                  <Render config={{ name: 'OperationList', type: 'view', operationList }} data={{ ...data, ...gameConfig }} changeData={changeData} />}
                {operationList?.name && <Render config={operationList} data={{ ...data, ...gameConfig }} changeData={changeData} />}
              </>
            }
          >
            {hasTab && <div className='header-tab'>
              <Tabs ceiling activeId={tabId} animated={false} tabs={tabsInfo.tabs}
                className='realtime-users-tab'
                onActive={(tab) => {
                  const url = `/dashboard/game/${gameCode}${pageConfig?.path}/${tab.id}`;
                  reset();
                  history.push(url);
                }}
                addon={tab.operationList && tab.operationList.length > 0 &&
                  <Render config={{ name: 'OperationList', type: 'view', operationList: tab.operationList }} data={{ ...data, ...gameConfig }} changeData={changeData} />}
              >
              </Tabs>
            </div>}
          </Content.Header>
        )}
        <Content.Body full>
          {
            system === 'dashboard' ? <ContentWrap timeZone={timeZone} data={data} changeData={changeData} config={tabsInfo.tabMap[tabId]} /> :
              <CommonContantWrap data={data} changeData={changeData} config={tabsInfo.tabMap[tabId]} />
          }

        </Content.Body>
      </Content >)
    }
  </>;
};

export default PageContainer;
